import React from 'react';

const EmbedType = (...types) => ({children}) =>
  types.includes(window.ENV.embedLinkType)
    ? React.Children.only(children)
    : null;

export const WhenPublic = EmbedType('SEARCHABLE', 'LINK_ONLY');
export const WhenSearchable = EmbedType('SEARCHABLE');
export const WhenLinkOnly = EmbedType('LINK_ONLY');
export const WhenPrivate = EmbedType('PRIVATE');
export const WhenUnknown = EmbedType('UNKNOWN');
